export const stateName = 'faqEntryState';